<template>
    <div>
        <div class="banner">
            <div class="headerReplacementWarrantHoldersInfo"></div>
            <div class="banner-text">
                <b>ข้อมูลสำหรับผู้ถือใบสำคัญแสดงสิทธิ</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
                    <span class="separator"></span>
                    <span><b>ข้อมูลสำหรับผู้ถือใบสำคัญแสดงสิทธิ</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <table class="table mt-3 mb-5">
                <thead>
                    <tr class="table-secondary">
                        <th scope="col"><b>ข้อมูลสำหรับผู้ถือใบสำคัญแสดงสิทธิ</b></th>
                        <th scope="col">ORI - WA ครั้งที่ 6</th>
                        <th scope="col">ORI - WB ครั้งที่ 6</th>
                        <th scope="col">ORI - WC ครั้งที่ 6</th>
                        <th scope="col">ORI - WD ครั้งที่ 6</th>
                        <th scope="col">ORI - W1 ครั้งสุดท้าย</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">แจ้งการใช้สิทธิซื้อหุ้นสามัญของใบสำคัญแสดงสิทธิที่จะซื้อหุ้นสามัญของบริษัท</th>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738901786918-20180823-ori-warrant-wa-06-notification-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>

                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738901936827-20200309-ori-warrant-wb-06-notification-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902016814-20210916-ori-warrant-wc-06-notification-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902086815-20220217-ori-warrant-wd-06-notification-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902171333-20200903-ori-warrant-w1-last-notification-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">ใบแจ้งความจำนงการใช้สิทธิตามใบสำคัญแสดงสิทธิที่จะซื้อหุ้นสามัญ</th>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902300918-20180823-ori-warrant-wa-06-subscription-form-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902389561-20200309-ori-warrant-wb-06-subscription-form-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902460386-20210916-ori-warrant-wc-06-subscription-form-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902523526-20220217-ori-warrant-wd-06-subscription-form-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902687764-20200903-ori-warrant-w1-last-subscription-form-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">แบบฟอร์มการชำระเงิน</th>
                        <td class="text-center">

                        </td>
                        <td class="text-center">

                        </td>
                        <td class="text-center">

                        </td>
                        <td class="text-center">

                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902777468-20200903-ori-warrant-w1-last-bill-payment.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">สรุปสาระสำคัญของการออกและเสนอขายใบสำคัญแสดงสิทธิให้แก่กรรมการ ผู้บริหารและพนักงาน
                        </th>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738902970314-20160311-ori-warrant-wa-summary-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738903041871-20170905-ori-warrant-wb-scheme-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738903141139-20180823-ori-warrant-wc-scheme-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738903192369-20190903-ori-warrant-wd-01-scheme-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                        <td class="text-center">

                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            ข้อกำหนดว่าด้วยสิทธิและหน้าที่ของผู้ออกใบสำคัญแสดงสิทธิและผู้ถือใบสำคัญแสดงสิทธิที่จะซื้อหุ้นสามัญ
                        </th>
                        <td class="text-center">

                        </td>
                        <td class="text-center">

                        </td>
                        <td class="text-center">

                        </td>
                        <td class="text-center">

                        </td>
                        <td class="text-center">
                            <a href="https://origin-console-service.onrender.com/api/upload/file/1738903280820-20171115-ori-warrant-w1-01-th.pdf"
                                target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    <!-- Add more rows as needed -->
                </tbody>
            </table>
        </div>
    </div>
</template>
  
<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        BasicInfoTabMenu,
    },
    data() {
        return {
            financialData: null,
        };
    },
    methods: {
        async init() {
            let response = await store.dispatch(GET_FINANCIAL_DATA);
            if (response) {
                this.financialData = response; // Assign fetched data to local state
            } else {
                console.error('Failed to fetch financial data');
            }
        },
    },

};
</script>
<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  